import React, { createContext, useContext, useState } from "react";

const PositionConText = createContext();

export const useGetPositionConText = () => useContext(PositionConText);

function GetPositionConText({ children }) {
  const [position, setPosition] = useState("");
  const clearValue = () => {
    setPosition('');
  };

  return (
    <PositionConText.Provider value={{ position, setPosition, clearValue }}>
      {children}
    </PositionConText.Provider>
  );
}

export default GetPositionConText;
